import { useSelector } from "react-redux";
const LabelLang = ({
  id,
  defaultValue,
  translations,
  className,
  link = null,
}) => {
  const currentLocale = useSelector(({ theme }) => theme.locale);

  const GetTranslation = () => {
    if (currentLocale === "ar") return defaultValue;
    if (translations?.length === 0) return defaultValue;
    let value = defaultValue;

    translations?.forEach((obj) => {
      if (currentLocale === obj.locale) {
        if (obj[id] !== "" && obj[id] !== null && obj[id] !== undefined) {
          value = obj[id];
        }
      }
    });
    return value;
  };
  return link !== null ? (
    <a href={link} target="_blank" rel="noreferrer">
      <GetTranslation />
    </a>
  ) : (
    <label className={className}>
      <GetTranslation />
    </label>
  );
};

export default LabelLang;

export const LabelLangString = ({
  id,
  defaultValue,
  translations,
  currentLocale,
}) => {
  if (currentLocale === "ar") return defaultValue;
  if (translations === undefined || translations?.length === 0)
    return defaultValue;
  let value = defaultValue;

  translations?.forEach((obj) => {
    if (currentLocale === obj.locale) {
      if (obj[id] !== "" && obj[id] !== null && obj[id] !== undefined) {
        value = obj[id];
      }
    }
  });
  return value;
};

export const LabelLangJSON = ({ id, defaultValue, translations }) => {
  const currentLocale = useSelector(({ theme }) => theme.locale);

  if (currentLocale === "ar") return defaultValue;
  if (translations === undefined || translations?.length === 0)
    return defaultValue;
  let value = defaultValue;
  translations?.forEach((obj) => {
    if (currentLocale === obj.locale) {
      if (
        obj.value !== undefined &&
        JSON.parse(obj.value) !== undefined &&
        JSON.parse(obj.value)[id] !== undefined &&
        JSON.parse(obj.value)[id] !== "" &&
        JSON.parse(obj.value)[id] !== null
      ) {
        value = JSON.parse(obj.value)[id];
      }
    }
  });
  return value;
};
